<template>
  <div class="container">
    <div class="help">
      <div class="help-body">
        <div class="help-title">隐私规则 Privacy rules</div>
        <div class="help-content">
          <div class="help-c-view">
            <b>隐私政策</b>
            <p>欢迎您使用我们的产品和服务！我们非常重视您的隐私保护和个人信息保护。本《个人信息保护政策》将帮助您了解以下内容：</p>
            <ul>
              <li>一、 引言</li>
              <li>二、 我们如何收集和使用您的个人信息</li>
              <li>三、 我们如何使用 Cookie 和同类技术</li>
              <li>四、 我们如何共享、转让、公开披露您的个人信息</li>
              <li>五、 我们如何保存及保护您的个人信息</li>
              <li>六、 您的权利</li>
              <li>七、 我们如何处理未成年人的个人信息</li>
              <li>八、 您的个人信息如何跨境转移</li>
              <li>九、 个人信息保护政策的修订</li>
              <li>十、 如何联系我们</li>
              <li>十一、 争议解决方式</li>
            </ul>
            <b>一、引言</b>
            <p>
              为切实保护播聘用户隐私权，优化用户体验，播聘根据现行法规及政策，制定本《个人信息保护政策》。本《个人信息保护政策》将详细说明播聘在获取、管理及保护用户个人信息方面的政策及措施。本《个人信息保护政策》适用于播聘公司向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的播聘服务。
              本《个人信息保护政策》旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。我们希望您在使用播聘服务前仔细阅读并明确您已经充分理解、接受本《个人信息保护政策》的内容，希望您可以根据自己的理解做出合适的选择。您一旦开始使用播聘平台服务，即表示您认同我们在本《个人信息保护政策》中所述内容。在我们更新本《个人信息保护政策》后，您继续使用我们的产品与/或服务，即意味着您同意本《个人信息保护政策》(含更新版本)内容，并且同意我们按照本《个人信息保护政策》收集、使用、保存和共享您的相关信息。此外，在将您的个人信息用于本《个人信息保护政策》未涵盖的用途时，我们会事先征求您的同意。
            </p>
            <b>二、我们如何收集和使用您的个人信息</b>
            <p>
              我们深知个人信息对您的重要性，也深知为您的信息提供有效保护是我们业务健康可持续发展的基石。感谢您对播聘平台的使用和信任！我们致力于维持您对我们的信任，恪守适用法律和我们对您的承诺，尽全力保证您的个人信息安全和合理使用。
              <b>我们郑重承诺，我们已按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</b>
              我们仅会出于本《个人信息保护政策》所述的以下目的，收集和使用您的个人信息。
            </p>
            <p>1、注册账号</p>您首先需要注册一个播聘账号成为播聘的注册用户。
            <b>当您注册时，您至少需要向我们提供您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效。</b>如果您不提供这些信息，不影响您通过web或wap页面进行浏览、搜索。
            <p>2、通过认证成为招聘用户</p>在注册成功后，为了保证发布职位的真实可信，您在播聘上发布职位前，需要通过实名认证，包括提供真实
            <b>姓名、性别、身份证号，以及面部特征</b>信息。发布职位前，您还需要提供所在
            <b>单位名称、担任岗位，</b>根据认证需要可能需要提供单位邮箱、工牌、在职证明其中的至少一种信息以证明您可以代表该单位进行招聘。如果您提交的单位首次在播聘上发布招聘信息，那么您还需要提供营业执照以验证单位的合法性。
            <p>3、发布职位</p>
            <b>您可以通过【弹窗】选择是否允许我们的产品收集您的定位信息（包括GPS定位、IP地址），</b>如果您要使用本平台的职位信息发布功能，则需同意提供您的定位信息。该信息将仅被用于为您提供岗位地址选择功能、进行帐号安全检测以及向您推荐您可能感兴趣的求职用户或职位。播聘不会将上述信息用作实现上述功能之外的其他用途。拒绝提供位置信息仅会使您无法享受基于位置的安全检测和个性化推荐，而不会影响您正常使用本平台的其他功能。
            <p>4、创建在线简历</p>在注册成功后，如果您需找工作，那么您首先需要填写一份
            <b>在线简历，包括生日、年龄、开始工作时间、过往工作经历（公司名称、担任职务、在职时间段、工作内容描述）、过往教育经历（毕业学校、学历、在校时间段、在校经历描述）、联系方式（微信、手机、电子邮箱）、期望工作（期望城市、期望薪资、期望行业、期望岗位）。</b>播聘将根据您的以上信息，根据推荐算法为您推荐合适的工作岗位。
            <b>您的个人敏感信息（包括手机号、电子邮箱、微信号）在您没有主动同意的情况下，不会展示给其他用户。</b>
            您可以在隐私设置中，设置在线简历信息隐藏，隐藏后招聘用户无法再浏览您的在线简历内容。基于公平性原则，如果您在在线简历隐藏状态下主动查看职位。那么您所查看职位所属的招聘用户可以看到您的在线简历信息（不包括任何联系方式）。
            <p>5、浏览招聘信息和求职用户的在线简历</p>为了让您快速地找到您所需要职位或求职用户，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、分辨率、服务提供商网络ID（PLMN））、浏览器类型来为您提供信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述信息。
            您也可以通过搜索功能来筛选您所需要的工作信息或求职用户。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关岗位或求职用户。请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本《个人信息保护政策》对其进行处理与保护。
            <p>6、购买增值服务</p>在您选择购买我们的付费权益等增值服务时，您可以选择第三方支付机构所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的购买明细、订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。
            “关联方”指存在关联关系的主体，包括但不限于存在母子公司、总分公司关系，直接或间接的控股关系，实际控制人、董事、监事、高级管理人员与该主体存在直接或者间接控制的关系，协议控制VIE结构，或从证券市场披露、其官方宣传等能够确认存在关联的关系等。
            “控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
            <p>7、在线沟通</p>当您在使用播聘，与求职用户或招聘用户进行线上沟通时，根据双方沟通意向，可能需要交换联系方式（包括电话、微信），要求发送附件简历文件。在一方主动发起，另一方主动同意的情况下，相互交换联系方式，或将求职用户的附件简历文件发送给招聘用户。
            当求职用户与招聘用户在线上达成面试意向，并通过播聘提供的约面试功能成功发出面试邀请，用户接受后需要向对方展示手机号、微信等常用联系方式，用于线下前往面试地点时候的必要联系。
            <p>8、改进我们产品所必须的功能</p>我们可能会收集您的IP地址、某按钮的点击使用时间和频率、某页面的使用时间和频率、某些关键配置的选项值、崩溃日志、错误日志等，用来将您感兴趣的职位、求职用户或求职招聘过程中您可能需要的服务信息展示给您，同时有可能用于统计我们产品的用户数量、分析产品的使用状况、网页升级改版、浏览器兼容性检测、排查崩溃原因、减少崩溃情况，以不断改进我们的产品。这些信息不涉及到您的个人身份等隐私信息。
            <p>9、保障求职招聘安全所必须的功能</p>为了增强播聘平台的求职招聘、在线面试等过程中的安全性，尽可能保障您或其他用户在招聘求职过程中的人身、财产安全免遭侵害，更好地预防求职诈骗等安全风险，更准确地识别违反法律法规或播聘相关协议规则的情况。我们可能使用或整合您的账户信息、设备信息、软件使用信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，用于判断您的账号风险、进行身份验证、检测我们认为有风险的行为以及防范平台安全事件，并采取必要的记录、审计、分析、处置措施。
            <p>10、家庭住址（非必须）</p>对于部分求职用户用户，用户可以提供家庭住址，用于在浏览职位时候查看工作地点距离居住地址的距离，和查看家庭住址附近的职位。
            <p>11.客服功能</p>我们可能会利用手机的信息（包括您的手机号、电子邮件地址）与您直接沟通或互动。发现账号异常后可能会向您发送通知。为保证您的账号安全，客服在接受您的咨询反馈前，会使用您的账号信息核验您的身份。
            <p>12.我们通过间接获得方式收集到您的个人信息 当您通过我们产品或服务使用播聘关联方、合作方服务时，您同意我们根据实际业务及合作需要从我们关联方、合作方处接收、使用、汇总、分析经您授权同意其向我们提供的您的个人信息。</p>
            <p>13.其他用途</p>在符合法律法规的前提下，我们可能会将您的个人信息在匿名化、汇总、脱敏和加密处理后，形成统计信息或用户画像（但画像无法识别任何用户个人），为您展示和推送相关服务、产品或功能。当我们要将信息用于本《个人信息保护政策》未载明的其他用途，将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
            <p>14.征得授权同意的例外</p>根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：
            <ul>
              <li>（1） 与国家安全、国防安全直接相关的；</li>
              <li>（2） 与公共安全、公共卫生、重大公共利益直接相关的；</li>
              <li>（3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
              <li>（4） 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
              <li>（5） 所收集的个人信息是您自行向社会公众公开的；</li>
              <li>（6） 从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；</li>
              <li>（7） 根据您的要求签订和履行合同所必需的；</li>
              <li>（8） 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
              <li>（9） 用于维护播聘平台产品和/或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；</li>
              <li>
                （10） 法律法规规定的其他情形。
                如果您对我们收集和使用您的个人信息有任何疑问或需要提供进一步的信息，请通过本《个人信息保护政策》公布的联系方式与我们联系。
              </li>
            </ul>
            <b>
              （10） 法律法规规定的其他情形。
              如果您对我们收集和使用您的个人信息有任何疑问或需要提供进一步的信息，请通过本《个人信息保护政策》公布的联系方式与我们联系。
            </b>
            <p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含用户身份标识符、城市名称称以及一些字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的服务。 我们不会将 Cookie 用于本《个人信息保护政策》所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 【AboutCookies.org】。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，但您可能因为该等修改，无法登录或使用依赖于Cookie的百度提供的服务或功能。 您可以通过更改您的浏览器设置限制播聘对Cookie的使用。以【Chrome】浏览器为例，您可以在【Chrome】浏览器右上方的下拉菜单的“浏览器设置”中，通过“【设置-高级-清楚浏览数据】”，选择清除您的Cookie。</p>
            <p>四、我们如何共享、转让、公开披露您的个人信息</p>
            我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。
            <p>1. 共享</p>我们会以高度的勤勉义务对待您的信息。除以下情形外，未经您同意，我们不会与除播聘公司及其关联公司外的任何第三方公司、组织和个人分享您的信息：
            <p>1.1为实现相关功能或服务与播聘关联方共享</p>为保障您在本平台公开展示的信息向播聘关联方（如“猎约”“秘聘汇”）的注册用户展示时的一致性，并方便统一管理您的信息展示，我们有可能会将您去标识化后的个人信息与非个人信息与“猎约”“秘聘汇”平台进行共享。
            <p>1.2为实现特定功能而与业务合作伙伴共享</p>当【软件服务提供商、智能设备提供商或系统服务提供商】与我们联合为您提供服务时，当您需要使用地理位置功能时，为实现这一功能，我们可能会收集您的位置信息及相关设备信息（包括硬件型号、操作系统版本号、国际移动设备身份识别码（IMEI）、网络设备硬件地址（MAC））经过去标识化后并提供给前述提供商。
            目前，我们的授权合作伙伴包括以下类型：
            <ul>
              <li>• 服务平台或服务提供商。播聘各产品接入了丰富的第三方服务。当您选择使用该第三方服务时，您授权我们将该信息提供给第三方服务平台或服务提供商，以便其基于相关信息为您提供服务，包括认证服务提供商，当您绑定播聘与认证平台账号时，我们将弹出授权确认页面，在向您告知收集上述信息并得到您授权的情况下，我们会将您的简历信息提供给认证平台，用于评价您的信用分。</li>
              <li>• 软硬件/系统服务提供商。当第三方软硬件/系统产品或服务与播聘的产品或服务结合为您提供服务时，经您授权，我们会向第三方软硬件/系统服务提供商提供您必要的个人信息，以便您使用服务，或用于我们分析产品和服务使用情况，来提升您的使用体验。</li>
              <li>• 广告、咨询类服务商/广告主。未经您授权，我们不会将您的个人信息与提供广告、咨询类服务商共享。但我们可能会将经处理无法识别您的身份且接收方无法复原的信息，包括经匿名化处理的用户画像，与广告或咨询类服务商或广告主共享，以帮助其在不识别您个人的前提下，提升广告有效触达率，以及分析我们的产品和服务使用情况等。</li>
            </ul>

            <p>1.3 为向您展示或推荐更多匹配的求职用户或满足期望的招聘职位。</p>您理解并同意我们将您在播聘展示的全部或部分信息，展示在猎约平台供其用户查看、开聊及其他类似行为， 因此您可能接收到来自猎约用户向您发出的开聊等信息。
            我们承诺在共享过程中，尽最大可能保障您的数据和隐私不受侵害，并以不低于本《个人信息保护政策》所要求的保密和安全措施来处理该些信息。
            如果您拒绝本条款的内容，请通过本《个人信息保护政策》公布的联系方式与我们联系。
            <p>1.4 对我们与之共享个人信息的其他公司、组织和个人，我们会与其签署严格的保密协议，并要求第三方以不低于本《个人信息保护政策》所要求的保密和安全措施来处理该些信息。</p>
            <p>2. 转让</p>
            我们不会将您的个人信息转让给除播聘公司及其关联公司外的任何公司、组织和个人，但以下情形除外：
            <p>2.1. 事先获得您的明确授权或同意；</p>
            <p>2.2. 满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；</p>
            <p>2.3. 如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
            <p>3. 公开披露</p>
            我们仅会在以下情形下，公开披露您的个人信息：
            <p>3.1 获得您的明确同意；</p>
            <p>3.2 基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</p>
            <p>4. 共享、转让、公开披露个人信息时事先征得授权同意的例外
            在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
            <p>4.1. 与国家安全、国防安全直接相关的；</p>
            <p>4.2. 与公共安全、公共卫生、重大公共利益直接相关的；</p>
            <p>4.3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
            <p>4.4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
            <p>4.5. 您自行向社会公众公开的个人信息；</p>
            <p>4.6. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
            <p>4.7. 根据个人信息主体要求签订和履行合同所必需的；</p>
            <p>4.8. 用于维护所提供的产品或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；</p>
            <p>4.9. 法律法规规定的其他情形。</p>
            根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
            <p>五、我们如何保存及保护您的个人信息</p>
            <p>1. 保存期限</p>
            您在使用播聘产品及服务期间，我们将持续为您保存您的个人信息。如果您注销帐户或主动删除上述信息，我们将依据网络安全法等法律法规规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，但我们可能会对您的个人信息进行删除或匿名化处理后使用。
            <p>2. 保存地域</p>
            您的个人信息均储存于中华人民共和国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
            <p>3一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息，下列情况下，我们有能因需符合法律要求，更改个人信息的存储时间：</p>
						<ul>
							<li>• 为遵守适用的法律法规等有关规定；</li>
							<li>• 遵守法院判决、裁定或其他法律程序的规定；</li>
							<li>• 为遵守相关政府机关或法定授权组织的要求；</li>
							<li>• 我们有理由确信需要遵守法律法规等有关规定；</li>
							<li>• 为执行相关服务协议或本《个人信息保护政策》、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
            当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</li>
						</ul>
            
            
           
            
            
            <p>4. 保护措施</p>
						<p>4.1我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对播聘网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全培训课程，加强员工对于保护个人信息重要性的认识。</p>
            <p>4.2我们从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过网络安全等级保护的测评。</p>
            <p>4.3我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本《个人信息保护政策》所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求）。</p>
            <p>4.4互联网并非绝对安全的环境，使用播聘平台服务时，我们强烈建议您不要使用非播聘平台推荐的通信方式发送您的信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、分享时，您可以自主选择沟通、分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。</p>
            <p>4.5在使用播聘服务进行沟通时，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即通过第十章公布的联系方式联络我们，以便我们根据您的申请采取相应措施。</p>
            <p>4.6请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评论、沟通时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。</p>
            
            <p>5. 安全事件通知</p>
            <p>5.1. 我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。</p>
            <p>5.2. 个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，由安全部、政府关系部、法务部等多个部门组成应急响应小组，在最短时间内追溯原因并减少损失。</p>
            <p>5.3. 在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时通过软件内部提醒、邮件、短信或电话等方式向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况通过上述方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
            我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过播聘公告方式获得。
            <p>六、您的权利</p>
            按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
            <p>1. 访问和修改您的个人信息</p>
						<ul>
							<li>1）访问修改姓名
            尚未完成实名认证的，可以在【我的>在线简历>点击姓名】，进行修改；每位用户三个月内只能修改一次；
            已经完成实名认证的求职用户，可以在 我的>在线简历 中显示和修改
            已经完成实名认证的招聘用户，可以在 我的>招聘管理 中显示和修改；</li>
						<li> 2）访问和修改性别
            尚未完成实名认证的求职用户，可以在 我的>在线简历>点击姓名>性别，更改显示；
            已经完成实名认证的用户，不能修改性别；</li>
						<li>3）访问和修改简历内容
            求职用户可以在 我的>在线简历 中修改简历内容
            求职用户可以在 我的>隐私设置 中修改简历 隐藏或展示
            求职用户可以在 我的>附件简历 增加新的附件简历文件或删除已有的附件简历文件</li>
						<li>4）访问和修改手机号
            用户可以在 我的>设置>修改手机号 中更换手机号</li>
						<li>5）访问和修改微信号
            招聘用户可以在 我的>招聘设置>微信号 中修改
            求职用户可以在 我的>在线简历>点击姓名>微信号中添加修改</li>
						<li>6）访问和修改住址
            求职用户可以在推荐列表>排序方式>附近 > 设置/更改住址 来添加或修改住址
            如果您无法通过上述链接访问该等个人信息，您可以通过本《个人信息保护政策》公布的联系方式与我们联系。
            您在使用我们的产品和服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请通过本《个人信息保护政策》的“十、如何联系我们”中公布的联系方式与我们联系。
            您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可以通过上述段落中列明的方式提出更正或补充申请。为保障安全，我们将在您行使更正权前对您的身份进行验证。</li>
						</ul>
            
           
            
            
            
            
            <p>2. 删除您的个人信息</p>
            在以下情形中，您可以向我们提出删除个人信息的请求，您可以通过“1. 访问和修改您的个人信息”中列明的方式或本《个人信息保护政策》公布的联系方式随时与我们联系：
            <p>2.1.如果我们违反法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息；</p>
            <p>2.2 如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。</p>
            <p>2.3我们没有征求您的明确同意，收集了您的个人信息。</p>
            <p>2.4我们违反了与您的约定来使用和处理您的个人信息。</p>
            您注销了播聘帐号、卸载或者不再使用我们的产品（或服务）。
            我们停止对您提供服务。
            <p>3.改变授权范围</p>
            <p>3.1改变或撤回敏感信息权限</p>
            您可以在设备本身操作系统中关闭地理位置、通讯录、摄像头、麦克风等权限改变同意范围或撤回您的授权。
            <p>3.2拒接受推送及营销信息</p>
            您可以通过手机设置关闭“推送通知”拒绝消息的推送，通过回复“TD”等退订我们的营销短信。
            <p>3.3请您理解，特定的业务功能和服务将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。</p>
            <p>4. 注销您的账户</p>
            您可以在我们产品的“帮助与反馈>账号管理>注销账号”中直接申请注销账户，也可以通过本《个人信息保护政策》公布的联系方式，申请注销播聘账号。需要注意的是，我们为了保护您或他人的合法权益、履行互联网平台的法律责任，在您的账号处于特殊状态下，虽然我们会支持您的请求，但您在成功注销后可能无法再次注册或使用播聘平台和服务，具体事项以《注销协议》为准。
            <p>5. 提前获知产品和服务停止运营</p>
            播聘愿一直陪伴您，若因特殊原因导致播聘平台被迫停止运营，我们将按照法律法规的要求，在产品和/或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等。
            <p>6. 响应您的上述请求</p>
            <p>6.1为保障安全，您需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
            <p>6.2对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
            <p>7. 响应请求的例外</p>
            在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：
						<ul>
							<li>• 与国家安全、国防安全直接相关的；</li>
							<li>• 与公共安全、公共卫生、重大公共利益直接相关的；</li>
							<li>• 与犯罪侦查、起诉、审判和执行判决等直接相关的；</li>
							<li>• 我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）；</li>
							<li> • 响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
							<li> • 涉及商业秘密的。</li>
						</ul>
            
            
            
            
           
           
            <p>七、我们如何处理未成年人的个人信息</p>
            播聘非常重视对未成年人信息的保护。
            基于我们的产品、网站和服务的性质，我们不向16周岁以下的未成年人提供服务，因此无收集相关信息。若您是已满16周岁不满18周岁的未成年人，建议您请您的监护人仔细阅读本《个人信息保护政策》，并在征得您的监护人同意的前提下使用我们的产品和/或服务或向我们提供信息。
            如您的监护人不同意您按照本《个人信息保护政策》使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
            如果监护人发现我们在未获监护人同意的情况下收集了未成年人的个人信息，请通过本《个人信息保护政策》公布的联系方式联系我们，我们会尽快删除相关数据。
            <p>八、您的个人信息如何进行跨境转移</p>
            原则上，我们在中国境内收集和产生的个人信息仅存储在中国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
            <p>九、本《个人信息保护政策》如何更新</p>
            我们可能适时修订本《个人信息保护政策》内容。如该等变更会导致您在本《个人信息保护政策》项下权利的实质变化，我们将在变更生效前，通过【推送系统消息、电子邮件、短信或网站公告】等方式通知您。
            若您不同意该等变更应停止使用播聘平台产品和服务，或通过本《个人信息保护政策》公布的联系方式要求暂时封停您的账号。若您继续使用我们的产品或服务，即表示您同意受修订后的本《个人信息保护政策》的约束。
            本《个人信息保护政策》所指的重大变更包括但不限于：
						<ul>
							<li>1. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
							<li>2. 个人信息共享、转让或公开披露的主要对象发生变化；</li>
							<li>3. 您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
							<li>4. 其他可能对您的个人信息权益产生重大影响的变化时；</li>
							<li>5. 个人信息出境情况发生变更时。</li>
						</ul>
            <p>十、如何联系我们</p>
            
            
            
            
            
            如果您对本《个人信息保护政策》及我们对您的个人信息的处理有任何疑问、意见、建议或投诉，请通过bp@abopin.com联系我们。
						<p>十一、争议解决</p>
            
            本《个人信息保护政策》与《播聘用户协议及隐私政策》共同构成您使用播聘服务的基本协议文件。本《个人信息保护政策》适用中华人民共和国现行法律法规。与本《个人信息保护政策》相关的争议，如果您对我们的回复或解决方案不满意，需要通过法律途径解决的，应将该争议提交至北京仲裁委员会，其仲裁裁决是终局的。
            <p>附录：定义</p>
            本《个人信息保护政策》中使用的特定词语，具有如下含义：
            <p>1. “我们”或“播聘公司”，指播聘网络技术(深圳)有限公司。</p>
            <p>2. “您”或“用户”，指使用播聘网络技术(深圳)有限公司运营的平台产品或服务的注册用户以及收费服务的购买方。</p>
            <p>3. “播聘平台”或“播聘软件”，指（http://www.abopin.com）播聘PC端及播聘手机客户端、播聘微信小程序。</p>
            <p>4. “个人信息”，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。</p>
            <p>5. “个人信息主体”，指个人信息所标识的自然人。</p>
            <p>6. “个人敏感信息”，指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息、个人身份信息、网络身份标识信息等。</p>
            <p>7. “去标识化”，指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</p>
            <p>8. “匿名化”，指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</p>
            <p>9. “中国”或“中国境内”，指中华人民共和国大陆地区，仅为本《个人信息保护政策》之目的，不包含香港特别行政区、澳门特别行政区和台湾地区。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: `ShowHelp`
};
</script>

<style scoped="scoped">
@import url("./privacy-rules.css");
</style>



// WEBPACK FOOTER //
// src/pages/privacy-rules/privacy-rules.vue